/* Mega menu acilis/kapanis animasyonu.

   Referans temada panel <details> icinde ve --transition-height degiskeniyle
   yuksekligi 0'dan icerik yuksekligine dogru aciliyor. Yukseklik CSS ile
   animasyonlanamaz (auto degeri araya deger uretmez), o yuzden yukseklik
   JS ile olculur ve piksel degeri uzerinden animasyon yapilir:

     acilis : height 0 -> scrollHeight, sonra auto (icerik degisirse bozulmasin)
     kapanis: height scrollHeight -> 0

   Temanin kendi gosterme/gizleme mantigina dokunulmaz; sadece panelin
   yuksekligi animasyonlanir. */

(function () {
  const DURATION = 460;
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  const findPanel = (item) =>
    item.querySelector('[header-menu-inner]') || item.querySelector('.header--menu-submenu');

  const openPanel = (panel) => {
    if (!panel || panel.dataset.mmAnim === 'open') return;
    panel.dataset.mmAnim = 'open';

    panel.style.overflow = 'hidden';
    panel.style.height = '0px';

    // Bir sonraki karede olc: 0 degeri tarayiciya islenmis olsun ki
    // gecis baslangic noktasini dogru alsin.
    requestAnimationFrame(() => {
      const target = panel.scrollHeight;
      panel.style.transition = `height ${DURATION}ms ${EASING}`;
      panel.style.height = `${target}px`;

      const done = (event) => {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', done);
        if (panel.dataset.mmAnim !== 'open') return;
        // Acilis bitince serbest birak: icerik degisirse panel kirpilmasin
        panel.style.transition = '';
        panel.style.height = 'auto';
        panel.style.overflow = '';
      };
      panel.addEventListener('transitionend', done);
    });
  };

  const closePanel = (panel) => {
    if (!panel || panel.dataset.mmAnim === 'closed') return;

    const current = panel.getBoundingClientRect().height;
    panel.dataset.mmAnim = 'closed';
    panel.style.overflow = 'hidden';
    panel.style.transition = 'none';
    panel.style.height = `${current}px`;

    requestAnimationFrame(() => {
      panel.style.transition = `height ${DURATION}ms ${EASING}`;
      panel.style.height = '0px';
    });
  };

  const setup = (item) => {
    if (item.dataset.mmOpenReady === 'true') return;
    const panel = findPanel(item);
    if (!panel) return;
    // Sadece bizim mega menu iceriklerimizde calis
    if (!panel.querySelector('.megamenu--cards, .megamenu--columns-wrap')) return;

    item.dataset.mmOpenReady = 'true';
    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
    panel.dataset.mmAnim = 'closed';

    item.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') return;
      openPanel(panel);
    });

    item.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      closePanel(panel);
    });

    // Klavye ile gezinme
    item.addEventListener('focusin', () => openPanel(panel));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) closePanel(panel);
    });
  };

  const init = () => {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.header--menu-item').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
